import React from "react";
import './ChatHeader.css';

import backIcon from "../../assets/new-images/up-arrow-icon.svg";
import { useConstants } from "../../constant/constantProvider";

const ChatHeader = ({
    onBack,
    backBtnText,
    title
}) => {
    const { BACK_TO_CHAT_GENIE } = useConstants();

    // If no title is provided, we don't render the header
    if (!title) return null;

    return (
        <div className="chat-end-section">
            <div className="chat-end-inner-section">
                <div className="box1">
                    {onBack && (
                        <button
                            className="back-button button-style"
                            onClick={onBack}
                        >
                            <img src={backIcon} alt="back-arrow" />
                            {backBtnText || BACK_TO_CHAT_GENIE}
                        </button>
                    )}
                </div>

                <div className="chat-header-text box2">
                    {title}
                </div>
            </div>
        </div>
    );
};

export default ChatHeader;
